import { useEffect } from "react";

const useFaviconBadge = (count = 0) => {
  useEffect(() => {
    const hasUnread = count > 0;
    const head = document.head;

    if (!window.__originalFavicon) {
      const existing = document.querySelector("link[rel*='icon']");
      window.__originalFavicon = existing?.href || "/favicon.ico";
    }
    if (!window.__originalTitle) {
      window.__originalTitle = document.title.replace(/^\(\d+\+?\)\s*/, "");
    }

    const setIcon = (href) => {
      const links = document.querySelectorAll("link[rel*='icon']");
      links.forEach((l) => l.parentNode && l.parentNode.removeChild(l));
      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png";
      link.href = href;
      head.appendChild(link);
    };

    const drawDotOnly = () => {
      const size = 64;
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#1a73e8";
      ctx.fillRect(0, 0, size, size);
      ctx.beginPath();
      ctx.arc(size - 16, 16, 14, 0, Math.PI * 2);
      ctx.fillStyle = "#EF4444";
      ctx.fill();
      ctx.lineWidth = 3;
      ctx.strokeStyle = "#FFFFFF";
      ctx.stroke();
      setIcon(canvas.toDataURL("image/png"));
    };

    const drawBadged = (sourceUrl) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const size = 64;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);
        const r = 14;
        const cx = size - r - 2;
        const cy = r + 2;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = "#EF4444";
        ctx.fill();
        ctx.lineWidth = 3;
        ctx.strokeStyle = "#FFFFFF";
        ctx.stroke();
        ctx.fillStyle = "#FFFFFF";
        ctx.font = `bold ${count <= 9 ? 18 : 14}px Arial, sans-serif`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(count > 9 ? "9+" : String(count), cx, cy + 1);
        try {
          setIcon(canvas.toDataURL("image/png"));
        } catch {
          drawDotOnly();
        }
      };
      img.onerror = () => drawDotOnly();
      img.src = sourceUrl;
    };

    if (hasUnread) {
      drawBadged(window.__originalFavicon);
      document.title = `(${count > 9 ? "9+" : count}) ${window.__originalTitle}`;
    } else {
      setIcon(window.__originalFavicon);
      document.title = window.__originalTitle;
    }
  }, [count]);
};

export default useFaviconBadge;
